module.exports = __webpack_public_path__ + "prev3.10b7d453.png";